export default "__VITE_ASSET__BDOAab7X__"